import * as React from 'react';
import { Button } from 'reactstrap';

interface FilterValueButtonProps {
	onClick?: () => void;
	id?: string;
	children: React.ReactNode;
}

/**
 * Component for filter item btn values
 *
 */
export default function FiltersListValueButton(props: FilterValueButtonProps) {
	return (
		<Button
			id={props.id}
			onClick={props.onClick}
			className="filters-list-item__name-btn"
			type="button"
			data-testid="filter-list-value-button"
		>
			{props.children}
		</Button>
	);
}
